import { useState } from 'react';
import { toast } from 'react-toastify';
import { fetchSelectedServiceRequestPDFExportDownloadList } from 'src/services/client';

export const useDownloadPDF = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const onDownloadPDF = async (
    userId: string,
    serviceRequestIds: string
  ): Promise<boolean> => {
    setIsLoading(true);
    setError(null);

    try {
      const response: any =
        await fetchSelectedServiceRequestPDFExportDownloadList(
          userId,
          serviceRequestIds
        );

      if (!response.ok) {
        throw new Error(`PDF download failed with status ${response.status}`);
      }

      const responseData: any = await response.json();

      toast.success(responseData.message, {
        autoClose: 10000,
        position: 'top-center',
      });

      return true;
    } catch (err: unknown) {
      console.error('PDF download failed:', err);
      const errorMessage =
        err instanceof Error
          ? err.message
          : 'PDF download failed, please try again.';
      setError(errorMessage);

      toast.error(
        ' 🚫 Something went wrong with exporting of service request PDF, please try again.',
        { autoClose: 12000, position: 'top-center' }
      );

      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const clearError = (): void => {
    setError(null);
  };

  return {
    isLoading,
    error,
    onDownloadPDF,
    clearError,
  };
};
